import { createContext, useContext, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { LOGOUT } from '../features/actions/Is-Logged-Actions';


export const AuthContext = createContext(null);


export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const BASE_URL = process.env.REACT_APP_AUTH_URL;
  const dispatch = useDispatch();


  // Check session from ecosystem's login endpoint
  const checkSession = async () => {
    try {
      const response = await fetch(`${BASE_URL}/api/auth/session`, {
        credentials: 'include' 
      });
      
      const session = await response.json();
      if (session && session.user){
        setLoading(false);
        setUser(session.user);
      }

      else {
        // Session expired, so force logout of Cumulus
        handleForcedLogout();
      }
     
    } catch (error) {
      console.error('Session check failed:', error);
      //setUser(null);
      handleForcedLogout();
    } finally {
      setLoading(false);
    } 
  };

  const handleForcedLogout = () => {
    setUser(null);
    dispatch(LOGOUT());
  };

  // Check when opening the app
  useEffect(() => {
    checkSession();
  }, []);

  // check session on window focus
  useEffect(() => {
    const handleFocus = () => {
      checkSession();
    };

    window.addEventListener('focus', handleFocus);
    document.addEventListener('visibilitychange', handleFocus);

    return () => {
      window.removeEventListener('focus', handleFocus);
      document.removeEventListener('visibilitychange', handleFocus);
    };
  }, []);

  // Check every 1 min
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     checkSession();
  //   }, 60000);

  //   return () => clearInterval(interval);
  // }, []);

// directs us to ecosystem login and will bring us back to current page
  const login = () => {
    const currentUrl = window.location.href;
    console.log("Redirecting with callbackUrl:", currentUrl);
    window.location.href = `${BASE_URL}/login?callbackUrl=${encodeURIComponent(currentUrl)}`;
  };
  


  const signOut = async () => {
    console.log('Signing out');
     console.trace();
    await fetch(`${BASE_URL}/logout`, {
      method: 'POST',
      credentials: 'include'
    });
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ 
      user, 
      loading, 
      login, 
      signOut, 
      checkSession 
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}


